import { getCsrfToken } from "../state/csrf";
import { Omgeving } from "../state/omgeving";
import { Publicatie } from "../state/publicaties";

/**
 * Officiële bekendmakingen in of nabij een gebied, uit het publicatieregister
 * van de omgevingsmonitor.
 *
 * POST, want de geometrie gaat mee: het perceelvlak dat de cube al leverde.
 * Publiek, net als de voorzieningen — het rapport vraagt niet om een account.
 * De server begrenst straal, venster én de omvang van de geometrie zelf.
 */
async function publicaties(geometry: GeoJSON.Geometry): Promise<Publicatie[]> {
  return post("/api/publicaties", geometry);
}

/**
 * Welke regelingen, documenten en bestemmingsplanregels hier gelden, als
 * compacte samenvatting. Traag voor een vers gebied (tot 90 s), dus alleen op
 * verzoek van de lezer.
 */
async function omgeving(geometry: GeoJSON.Geometry): Promise<Omgeving> {
  return post("/api/omgeving", geometry);
}

async function post(url: string, geometry: GeoJSON.Geometry) {
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-CSRFToken": getCsrfToken() },
    body: JSON.stringify({ geometry }),
  });
  if (!response.ok) throw new Error(`HTTP status ${response.status}`);
  return response.json();
}

export const OmgevingService = { publicaties, omgeving };
